module.exports = __webpack_public_path__ + "static/media/RaisingChildren_ios_2_preview.7c1c6604.jpg";